"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ConfigService = (function () {
    function ConfigService() {
    }
    Object.defineProperty(ConfigService.prototype, "token", {
        get: function () {
            if (!!!this._token) {
                this._token = window.localStorage.getItem('ls.auth:access_token');
            }
            return this._token;
        },
        set: function (key) {
            window.localStorage.setItem('ls.auth:access_token', key);
            this._token = key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "restaurantId", {
        get: function () {
            if (!!!this._restaurantId) {
                this._restaurantId = window.localStorage.getItem('ls.auth:selected_restaurant_key');
            }
            return this._restaurantId;
        },
        set: function (id) {
            window.localStorage.setItem('ls.auth:selected_restaurant_key', id);
            this._restaurantId = id;
        },
        enumerable: true,
        configurable: true
    });
    return ConfigService;
}());
ConfigService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], ConfigService);
exports.ConfigService = ConfigService;
